import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs, doc, writeBatch } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";

// TODO: Replace with your Firebase project config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "YOUR_API_KEY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "YOUR_PROJECT.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "YOUR_PROJECT_ID",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "YOUR_PROJECT.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "000000000000",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "YOUR_APP_ID",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;

// Exposes the running app's own Firestore/Auth/Storage instances (and the exact
// Firestore/Storage function references bound to that same SDK module instance -
// a console script importing its own copy from a CDN gets rejected by
// Firebase's internal type checks even though it's a "real" Firestore) for
// one-off admin scripts (e.g. .scripts/migrate-pools-to-subcollection.js)
// to use from the browser console, so they operate as whoever is actually
// logged into this tab instead of guessing at a session via a second SDK
// instance.
if (typeof window !== "undefined") {
  window.__hemaDb = db;
  window.__hemaAuth = auth;
  window.__hemaStorage = { storage, storageRef, uploadBytes, getDownloadURL };
  window.__hemaFirestore = { collection, getDocs, doc, writeBatch };
}
